import { settingsRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [
  IRoleEnum.SUPER_ADMIN,
  IRoleEnum.Teacher,
  IRoleEnum.ASSISTANT,
];

const settingsRouteMetadata: IRouteMetadataObj<typeof settingsRoutesObj> = {
  home: {
    title: "settings.title",
    description: "settings.description",
    lazy: () => import("@pages/settings/page"),
    mode: "index",
    type: "inner",
    icon: "Settings2Line",
    breadcrumbs: [],
    permission,
  },
};

export const settingsRoutes = createRoute<typeof settingsRoutesObj>(
  settingsRoutesObj,
  settingsRouteMetadata,
);
